/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ComplexAggregation,
    ComplexAggregationFromJSON,
    ComplexAggregationFromJSONTyped,
    ComplexAggregationToJSON,
    DateComplete,
    DateCompleteFromJSON,
    DateCompleteFromJSONTyped,
    DateCompleteToJSON,
} from './';

/**
 * 
 * @export
 * @interface AggregateItemResponse
 */
export interface AggregateItemResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ComplexAggregation>}
     * @memberof AggregateItemResponse
     */
    complexes: Array<ComplexAggregation>;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    maxPrice: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    minPrice: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    minArea: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    maxArea: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    minFloor: number;
    /**
     * 
     * @type {number}
     * @memberof AggregateItemResponse
     */
    maxFloor: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AggregateItemResponse
     */
    roomsFilter: Array<string>;
    /**
     * 
     * @type {Array<DateComplete>}
     * @memberof AggregateItemResponse
     */
    dateComplete: Array<DateComplete>;
}

export function AggregateItemResponseFromJSON(json: any): AggregateItemResponse {
    return AggregateItemResponseFromJSONTyped(json, false);
}

export function AggregateItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregateItemResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'complexes': ((json['complexes'] as Array<any>).map(ComplexAggregationFromJSON)),
        'maxPrice': json['maxPrice'],
        'minPrice': json['minPrice'],
        'minArea': json['minArea'],
        'maxArea': json['maxArea'],
        'minFloor': json['minFloor'],
        'maxFloor': json['maxFloor'],
        'roomsFilter': json['roomsFilter'],
        'dateComplete': ((json['dateComplete'] as Array<any>).map(DateCompleteFromJSON)),
    };
}

export function AggregateItemResponseToJSON(value?: AggregateItemResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'complexes': ((value.complexes as Array<any>).map(ComplexAggregationToJSON)),
        'maxPrice': value.maxPrice,
        'minPrice': value.minPrice,
        'minArea': value.minArea,
        'maxArea': value.maxArea,
        'minFloor': value.minFloor,
        'maxFloor': value.maxFloor,
        'roomsFilter': value.roomsFilter,
        'dateComplete': ((value.dateComplete as Array<any>).map(DateCompleteToJSON)),
    };
}


